// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { adminActions as actions } from '.';
/* import {
  sagaRequestTemplate,  
  sagaSpecialRequestTemplate,
  sagaPaginationRequestTemplate
} from 'utils/tools/slice-actions'; */

// import { selectAdminSlice } from './selectors';

/* function* fetchDetails({ payload }) {
    yield call(
      sagaRequestTemplate,
      requestUrl,
      payload,
      actions,
      'fetchActionSuccess',
      'fetchActionError',
      error message,
      otherRequestArgs
    );
  } */

/* function* updateDetails({ payload }) {
    yield call(
      sagaSpecialRequestTemplate,
      requestUrl,
      payload,
      actions,
      'updateActionEnd',
      'updateActionError',
      error message,
      success message,
      otherRequestArgs,
    );
  } */

/* function* fetchPagedDetails({ payload }) {
    yield call(
      sagaPaginationRequestTemplate,
      requestUrl,
      payload,
      actions,
      'fetchPageActionEnd',
      'fetchPageActionError',
      'error message',
      selectAdminSlice,
      otherRequestArgs
    );
  } */

export function* adminSaga() {
  // yield takeLatest(actions.fetchActionStart.type, fetchDetails);
  // yield takeLatest(actions.updateActionStart.type, updateDetails);
  // yield takeLatest(actions.fetchPageActionStart.type, fetchPagedDetails);
}
